// Click-and-drag horizontal scrolling for mouse users.
// Touch and trackpads already scroll these lists natively.
// Uses event delegation, so lists added to the page later work too.
export const enableDragScroll = (selector: string): void => {
  let list: HTMLElement | null = null;
  let startX = 0;
  let startScroll = 0;
  let dragged = false;

  document.addEventListener('pointerdown', (event: PointerEvent) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;

    const target = (event.target as HTMLElement).closest(selector) as HTMLElement | null;
    if (!target || target.scrollWidth <= target.clientWidth) return;

    list = target;
    startX = event.clientX;
    startScroll = list.scrollLeft;
    dragged = false;
  });

  document.addEventListener('pointermove', (event: PointerEvent) => {
    if (!list) return;

    const distance = event.clientX - startX;

    // small movements still count as a click
    if (!dragged && Math.abs(distance) < 5) return;

    if (!dragged) {
      dragged = true;
      list.classList.add('is-dragging');
    }

    list.scrollLeft = startScroll - distance;
  });

  const endDrag = () => {
    if (!list) return;

    list.classList.remove('is-dragging');
    list = null;

    // the click that ends a drag runs first, then reset
    setTimeout(() => {
      dragged = false;
    }, 0);
  };

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  // a drag shouldn't open the product it started on
  document.addEventListener(
    'click',
    (event: MouseEvent) => {
      if (dragged && (event.target as HTMLElement).closest(selector)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  // stop the browser dragging the photo or link itself
  document.addEventListener('dragstart', (event: DragEvent) => {
    if ((event.target as HTMLElement).closest?.(selector)) event.preventDefault();
  });
};
